window.addEventListener('DOMContentLoaded', () => {
  const section = $('[data-pairs-well-section]')
  const data = JSON.parse($(section).text())
  let featuredCollectionSlider = $('.pairs-well-with__collection.layout--slider .slider-gallery');

  const slideData = {
    products_per_slide: data.products_per,
    products_available: data.products_available,
    products_limit: data.products_limit,
    cellAlign: "left",
    wrapAround: false
  }

  $(featuredCollectionSlider).flickity({
    lazyLoad: 2,
    freeScroll: true,
    imagesLoaded: true,
    draggable: true,
    cellAlign: 'center',
    wrapAround: slideData.wrapAround,
    pageDots: false,
    contain: true,
    prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
    initialIndex: 0,
    arrowShape: arrowShape,
    on: {
      ready: function() {
        // Resize flickity when the slider is settled
        $(featuredCollectionSlider).on( 'settle.flickity', function() {
          $(featuredCollectionSlider).flickity('resize')
        });
      }
    }
  });
  
})